import { createContext, useContext } from "react";

import type { AccountLimitTypeMap } from "../generic/hooks/use-account-limit";
import type { FC, ReactNode } from "react";

const AccountLimitContext = createContext<AccountLimitTypeMap | null>(null);

interface AccountLimitProviderProps {
  limits: AccountLimitTypeMap;
  children: ReactNode;
}

export const AccountLimitProvider: FC<AccountLimitProviderProps> = ({ limits, children }) => (
  <AccountLimitContext.Provider value={limits}>{children}</AccountLimitContext.Provider>
);

export const useAccountLimitsContext = (): AccountLimitTypeMap => {
  const context = useContext(AccountLimitContext);
  if (!context) {
    throw new Error("useAccountLimitsContext must be used within an AccountLimitProvider");
  }
  return context;
};
